import { create } from "zustand";
import { persist } from "zustand/middleware";

interface MonthSelectorState {
  selectedMonth: number;
  setSelectedMonth: (month: number) => void;
}

export const useMonthSelector = create<MonthSelectorState>()(
  persist(
    (set) => ({
      selectedMonth: 1,
      setSelectedMonth: (month) => set({ selectedMonth: month }),
    }),
    {
      name: "month-selector-storage",
    }
  )
);
